<h2 class="bd-title">Event Priority</h2>
@if (errorMessage) {
<alert type="danger" [dismissible]="true" (onClose)="errorMessage = undefined">
  <coso-alert-message>
    <div class="d-inline" [innerHTML]="errorMessage"></div>
  </coso-alert-message>
</alert>
}

<form #settingsForm="ngForm" id="settingsForm">
  @if (settings$ | async; as settings) { @if ({ isLoading: loadingService.isSpinnerActive$('loadEventPriority') | async }; as loadingState) { @if (!loadingState.isLoading) {
  <div class="cs-row">
    <div class="cs-label-wrapper">
      <div id="label" class="cs-larger-text cs-bolder-text">Customize event priority</div>
      <div id="subLabel" class="cs-secondary-text">
        Set the priority in which events triggered by Dynamics 365 will be processed. The events with higher priority will be processed before events with lower priority.
      </div>
    </div>
  </div>
  <div class="cs-padded-left-wrapper">
    @for (event of events; track event) {
    <div class="form-group row">
      <label class="col-form-label col-lg-7 col-md-12 text-lg-left" for="{{ event.name }}">{{ getEventName(event) }}</label>
      <div class="col-lg-5 col-md-12">
        <select class="form-control" id="{{ event.name }}" name="{{ event.name }}" [(ngModel)]="event.priority" (ngModelChange)="eventPriorityChanged(settings, event)" [disabled]="readonly$ | async">
          @for (itemPriority of itemPriorities; track itemPriority) {
          <option [ngValue]="ItemPriority[itemPriority]">{{ getItemPriorityName(itemPriority) }}</option>
          }
        </select>
      </div>
    </div>
    }
  </div>
  } } }
</form>
